import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react'
import * as SwitchPrimitive from '@radix-ui/react-switch'

import cn from '@components/utils/cn'

export type SwitchProps = ComponentPropsWithoutRef<typeof SwitchPrimitive.Root> & {
  ref?: Ref<ComponentRef<typeof SwitchPrimitive.Root>>
}

export function Switch({ className, ref, ...props }: SwitchProps) {
  return (
    <SwitchPrimitive.Root
      ref={ref}
      data-slot="switch"
      className={cn(
        'tw:peer tw:inline-flex tw:h-6 tw:w-11 tw:shrink-0 tw:cursor-pointer tw:items-center tw:rounded-full tw:border-2 tw:border-transparent tw:transition-colors tw:motion-reduce:transition-none',
        'tw:focus-visible:outline-hidden tw:focus-visible:ring-4 tw:focus-visible:ring-primary-300',
        'tw:disabled:cursor-not-allowed tw:disabled:opacity-50',
        'tw:data-[state=checked]:bg-primary-600 tw:data-[state=unchecked]:bg-gray-cool-400',
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className="tw:pointer-events-none tw:block tw:h-5 tw:w-5 tw:rounded-full tw:bg-white tw:shadow tw:ring-0 tw:transition-transform tw:motion-reduce:transition-none tw:data-[state=checked]:translate-x-5 tw:data-[state=unchecked]:translate-x-0"
      />
    </SwitchPrimitive.Root>
  )
}
